import React from 'react';
import CheckboxesWrapper from './CheckboxesWrapper';
import View from './View';
import withAllTasksQuery from './withAllTasksQuery';

function TasksManagerList(props) {
  return (
    <CheckboxesWrapper tasks={props.tasks}>
      {checkboxesProps => <View {...props} checkboxesProps={checkboxesProps} />}
    </CheckboxesWrapper>
  );
}

export default withAllTasksQuery(TasksManagerList);



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/index.js